import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  private readonly baseApiUrl = environment.API_BASE_URL + '/plan';

  constructor(private readonly http: HttpClient) {}

  /**
   * Asks to move from Trial to Standard. The API opens the support case and tells staff;
   * no body, because everything it needs comes from the signed-in tenant. Answers 409 with
   * `plan_change_already_requested` when a request is already open.
   */
  requestUpgrade(): Observable<void> {
    return this.http.post<void>(`${this.baseApiUrl}/request-upgrade`, {});
  }
}
